export * from "@/ui/components/typography/TextControl/TextControl";
export * from "@/ui/components/typography/TextControl/TextControl.config";
